<template>
  <div>

    <div class="modal fade" id="modal-edit-file-uncategorized" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit!</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="new-category">File Name</label>
              <input type="text" class="form-control" autocomplete="nope" v-model="nameFile">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button class="btn btn-success" @click.prevent="confirmEditFile()">Save</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-remove-uncategorized" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Warning!</h5>
          </div>
          <div class="modal-body">
            Are you sure you want to delete the file?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button class="btn btn-danger" @click="confirmRemove()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" >
      <div class="col-sm-6 col-md-4 mb-4" v-for="doc in docs" :key="doc['.key']">
        <div class="c-card card">
          <div class="card-body d-flex flex-column align-items-center text-center">
            <font-awesome-icon class="c-card__icon-file mb-3" :icon="['fal', 'file-pdf']"></font-awesome-icon>
            <h5 class="c-main__title mb-3">{{ doc.name }}</h5>
            <div class="row w-100">
              <div class="col-md-6">
                <a :href="doc.url" class="btn btn-block btn-warning" target="_blank">View File</a>
              </div>
              <div class="col-md-3">
                <button type="button" class="btn btn-info btn-block" data-toggle="modal"
                        data-target="#modal-edit-file-uncategorized"
                        @click.prevent="nameFile = doc.name, dataFile = { key: doc['.key'], fullname: doc.fullname, url: doc.url }">
                  <font-awesome-icon :icon="['fal', 'edit']"></font-awesome-icon>
                </button>
              </div>
              <div class="col-md-3">
                <button type="button" class="btn btn-danger btn-block" data-toggle="modal"
                        data-target="#modal-remove-uncategorized"
                        @click.prevent="dataFile = { key: doc['.key'], fullname: doc.fullname }">
                  <font-awesome-icon :icon="['fal', 'trash']"></font-awesome-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { categories, storageFiles } from '../../firebase'
  import { busNotifications } from '../../bus'

  export default {
    props: [ 'category' ],
    data() {
      return {
        nameFile: '',
        dataFile: {}
      }
    },
    firestore() {
      return {
        docs: categories.doc(this.category).collection('uncategorized')
      }
    },
    methods: {
      confirmEditFile() {
        const fileRef = categories.doc(this.category).collection('uncategorized');
        fileRef.doc(this.dataFile.key).update({
          name: this.nameFile,
          fullname: this.dataFile.fullname,
          url: this.dataFile.url
        }).then( () => {
          busNotifications.makeNotification('success', 'The changes were saved successfully')
        });
        $('#modal-edit-file-uncategorized' ).modal('hide')
      },
      confirmRemove() {
        const key = this.dataFile.key;
        const category = this.category;
        const desertRef = storageFiles.child('public/files/' + this.dataFile.fullname);

        desertRef.delete().then(function() {
          const fileRef = categories.doc(category).collection('uncategorized');
          fileRef.doc(key).delete().then( () => {
            busNotifications.makeNotification('success', 'The file was deleted')
          })
        });
        $('#modal-remove-uncategorized').modal('hide')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/DocsUncategorized.vue